import { ButtonVariants } from 'core-system/Button/Button'
import { AdminLocations, adminLocationData } from './AdminLocation'
import { EmployeeLocations, employeeLocationData } from './EmployeeLocations'

export const Locations = {
  Login: '/login',
  ResetPassword: '/reset-password',
  EmployeeSignUp: '/employee-sign-up',
  EmployerSignUp: '/employer-sign-up',
  EmployerEmailConfirmation: '/email-confirmation',
  MCPConsent: '/mcp/consent',
  Error: '/error',
  ...AdminLocations,
  ...EmployeeLocations,
}

export const arrayOfRoutes = (locations: Dictionary) => {
  const routes = []
  Object.values(locations).forEach((location) => {
    if (typeof location === 'object') {
      routes.push(
        ...Object.values(location).map((x) => {
          return { path: x }
        })
      )
    } else {
      routes.push({ path: location })
    }
  })
  return routes
}

export interface LocationData {
  title?: string
  path?: string[]
  ignoreMaxWidth?: boolean
  hasDate?: boolean
  head?: string
  btnVariant?: ButtonVariants
  btnType?: 'sidebar' | 'cta'
  btnText?: string
  analyticsTitle?: string
  noPadding?: boolean
  showVerticalScroll?: boolean
  customHeader?: boolean // If true, PageHeader will render custom content for this page
}

export const locationData: Dictionary<LocationData> = {
  [Locations.Error]: {
    title: 'Not Found',
  },

  ...adminLocationData,
  ...employeeLocationData,
}
